export default "__VITE_ASSET__BUVjaIzg__"